import {
  useCallback, useMemo 
} from "react";
import classes from "./filterItem.module.css";

const FilterItem = (props) => {
  const {
    filterApi,
    filterState,
    group,
    item,
    onApply,
    onFilterItemMouseDown,
  } = props
  const {
    removeGroup, addItem 
  } = filterApi
  const {
    title, value, count 
  } = item

  const isSelected = filterState && filterState.has(item)

  // create and memoize an item that matches the tile interface
  const tileItem = useMemo(
    () => ({
      label: title,
      value_index: value,
    }),
    [title, value]
  )

  const handleClick = useCallback(
    (e) => {
      onFilterItemMouseDown()

      // use only left click for selection
      if (e.button !== 0) { return }

      removeGroup({
        group 
      })

      addItem({
        group, item 
      })

      if (typeof onApply === "function") {
        onApply(group, item)
      }
    },
    [group, item, removeGroup, addItem, onApply]
  )

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()

        removeGroup({
          group 
        })

        addItem({
          group, item 
        })

        if (typeof onApply === "function") {
          onApply(group, item)
        }
      }
    },
    [group, item, onApply, removeGroup, addItem]
  )

  return (
    <div
      className={`${classes.root} ${isSelected ? classes.rootActive : ""
      }`}
      onMouseDown={handleClick}
      onKeyDown={handleKeyDown}
    >
      <span className={classes.title}>{title}</span>
      <span className={classes.count}>({count})</span>
    </div>
  )
}

export default FilterItem
